import { BrowserRouter as Router, Routes, Route, Navigate  } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import LoginUserScreen from "./screens/LoginUserScreen";
import UserScreen from "./screens/UserScreen";
import ManageScreen from "./screens/ManageScreen";
import './App.css'; 
import StudentDashboard from "./screens/StudentDashboard";
import SidebarLayout from "./screens/SidebarLayout";


function App() {
  const isAuthenticated = localStorage.getItem('loggedIn') === 'true';
  const isUser = localStorage.getItem('loggedIn') === 'true';
  const isAdmin = localStorage.getItem('type') == 'admin' || localStorage.getItem('type') == 'owner';

  // return(<div>Server under upgradation, please check back later or contact support!</div>)

  return (
   <>
     <Router>
      <Routes>
        {isAuthenticated && isUser ? (
          <Route path="/" element={<UserScreen />} />
        ) : (
          <Route path="/" element={<LoginUserScreen />} />
        )}
        {isAuthenticated && isUser && !isAdmin ? (
          <>
          <Route path="/admin" element={<HomeScreen />} />
          <Route path="/student-dashboard" element={<StudentDashboard />} />
          </>
        ) : (
          <Route path="/admin" element={<LoginScreen />} />
        )}
        {isAuthenticated && isUser ? (
          <Route path="/manage" element={<ManageScreen />} />
        ) : (
          <Route path="/manage" element={<LoginScreen />} />
        )}
        <Route path="*" element={<LoginUserScreen />} />
      </Routes>
    </Router>
   </>
  );
}

export default App;
